<template>
  <v-card class="text-xs-center">
    <h1 class="text-pagename">Extra time management</h1>
    <extraTimeManage/>
  </v-card>
</template>

<script>

import extraTimeManage from "@/components/back-office/Messenger/ExtraTime/ExtraTimeListTable";
export default {
  components: {
    extraTimeManage
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href:  "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href:  "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Messenger",
        disabled: false,
        href:
           "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/messenger/extratime"
      },
      {
        text: "Extra time Management",
        disabled: true,
        href:
           "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/messenger/extratime"
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style>
</style>
